class PreLoading {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
    }
    run() {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // The video is near the viewport
                    var video = entry.target;
                    video.preload = 'auto';
                    video.addEventListener('loadeddata', function () {
                        // Video has been preloaded, do something here
                    });
                    // Stop observing the video since it has been loaded
                    observer.unobserve(video);
                }
            });
        }, {
            rootMargin: "0px 0px " + window.innerHeight + "px 0px"
        });

        // Get all the video elements on the page
        var videos = document.querySelectorAll('video');

        // Loop through each video element and observe it
        videos.forEach(function (video) {
            observer.observe(video);
        });
    }
}

export default PreLoading